module.exports = __webpack_public_path__ + "components/flag/static/square/gr-ce43c1df31dd6ae4c7a3d35cd2a3a4aa.svg";